import React from 'react';
import PropTypes from 'prop-types';
import {
  ColoredNoShadowHelpIcon,
  RegularEyeVisualImpairmentIcon,
  RegularSettingsIcon,
} from './icons';
import styles from './HelpNavButton.module.scss';
import { ReactComponent as CloseIcon } from '../../../../images/icons-regular-icons-ic-close.svg';

export const HelpNavButton = ({ showAccessibilityModal, onClose }) => {
  return (
    <div className={styles.rootContainer}>
      <div className={styles.root}>
        <div className={styles.help}>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseIcon />
          </button>
          <ColoredNoShadowHelpIcon className={styles.helpIcon} />
          <div className={styles.helpContent}>
            <span className={styles.helpText}>Помощь</span>8 800 222 2222
          </div>
        </div>
        <a onClick={showAccessibilityModal} className={styles.visuallyImpaired}>
          <RegularEyeVisualImpairmentIcon /> Для слабовидящих
        </a>
        <a
          href="https://www.nalog.gov.ru/rn77/service/service_feedback/?service=51"
          className={styles.technicalSupport}
        >
          <RegularSettingsIcon /> Техническая поддержка
        </a>
      </div>
    </div>
  );
};

HelpNavButton.propTypes = {
  showAccessibilityModal: PropTypes.func,
  onClose: PropTypes.func,
};
